import React from "react";

/**
 * Responsive data table: real table on md+, stacked cards on mobile.
 * columns: [{ key, label, render?, primary?, accent? }]
 */
export default function StatTable({ columns, rows, rowKey, testIdPrefix, emptyLabel = "No data." }) {
  if (!rows || rows.length === 0) {
    return <div className="py-14 text-center text-zinc-400 text-sm">{emptyLabel}</div>;
  }
  const primary = columns.find((c) => c.primary) || columns[0];
  const rest = columns.filter((c) => c !== primary);
  const cell = (col, row) => (col.render ? col.render(row) : row[col.key]);

  return (
    <>
      {/* Mobile cards */}
      <div className="lg:hidden divide-y divide-[#1B2226]">
        {rows.map((row) => (
          <div key={rowKey(row)} data-testid={`${testIdPrefix}-${rowKey(row)}`} className="p-4">
            <div className="font-mono text-sm text-white break-words">{cell(primary, row)}</div>
            <div className="mt-3 grid grid-cols-2 gap-x-4 gap-y-2.5">
              {rest.map((col) => (
                <div key={col.key} className="min-w-0">
                  <div className="text-[9px] font-mono uppercase tracking-[0.14em] text-zinc-500">{col.label}</div>
                  <div className={`font-mono text-sm mt-0.5 truncate ${col.accent?.(row) || "text-zinc-200"}`}>
                    {cell(col, row)}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      {/* Desktop table */}
      <div className="hidden lg:block overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-[10px] font-mono uppercase tracking-wider text-zinc-500 border-b border-[#242B30]">
              {columns.map((c) => (
                <th key={c.key} className="text-left px-4 py-3 font-medium whitespace-nowrap">{c.label}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={rowKey(row)} data-testid={`${testIdPrefix}-row-${rowKey(row)}`}
                className="border-b border-[#1B2226] hover:bg-[#0F1315] font-mono text-zinc-300">
                {columns.map((c) => (
                  <td key={c.key} className={`px-4 py-3 whitespace-nowrap ${c.primary ? "text-white" : ""} ${c.accent?.(row) || ""}`}>
                    {cell(c, row)}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
